import { BlobPicture } from "./BlobPicture";
import { PictureForWebClient } from "./PictureForWebClient";


export class PictureConverter
{
    public static Convert(picture: PictureForWebClient): BlobPicture
    {
        const blob = new Blob([picture.Image], { type: 'image/jpeg' });

        const blopPicture = new BlobPicture(blob, picture.PictureTime, picture.IndexFromDevice);
     
        return blopPicture;
    }
}
